var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "list-group-item list-group-item-action rounded-0 border-0 pointer",
    attrs: {
      "href": "#",
      "title": _vm.source.display
    },
    on: {
      "click": function ($event) {
        return _vm.dispatch($event, 'selected', _vm.source);
      }
    }
  }, [_c('div', {
    staticClass: "h5 m-0"
  }, [_vm._v(" " + _vm._s(_vm.source.entityName) + " "), _vm.source.programName ? _c('span', {
    staticClass: "font-weight-normal d-none d-lg-inline font-italic text-muted"
  }, [_vm._v(" , " + _vm._s(_vm.source.programName) + " ")]) : _vm._e(), _vm.source.programName ? _c('span', {
    staticClass: "font-weight-normal d-block d-lg-none text-muted"
  }, [_vm._v(" " + _vm._s(_vm.source.programName) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "text-secondary font-weight-bold"
  }, [_vm._v(_vm._s(_vm.source.type))])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };